'use strict';

module.exports = require('./es6/crc16ccitt').default;



//////////////////
// WEBPACK FOOTER
// ./~/crc/lib/crc16_ccitt.js
// module id = 640
// module chunks = 0